import React from "react";
import dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

import StyledNotAllDayPicker from "./styles";

dayjs.extend(dayOfYear);

function NotAllDayPicker({
  startDate,
  endDate,
  onStartTimeChange,
  onEndTimeChange,
  onSingleDayChange,
}) {
  return (
    <StyledNotAllDayPicker>
      <div className="not-all-day-picker">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="day-picker">
            <DatePicker
              label="Basic date picker"
              value={dayjs(new Date(startDate))}
              onChange={(date) => {
                let newDate = dayjs(date).toISOString();
                newDate = newDate.split("T")[0];

                onSingleDayChange(newDate);
              }}
            />
          </div>
          <div className="hour-picker">
            <TimePicker
              label="Desde"
              value={dayjs(new Date(startDate))}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
              onChange={(time) => {
                const newTame = dayjs(time);

                const hours = newTame.hour().toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                });
                const minutes = newTame.minute().toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                });

                onStartTimeChange(`${hours}:${minutes}`);
              }}
            />
            <TimePicker
              label="Hasta"
              value={dayjs(new Date(endDate))}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
              onChange={(time) => {
                const newTame = dayjs(time);
                const hours = newTame.hour().toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                });
                const minutes = newTame.minute().toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                });
                onEndTimeChange(`${hours}:${minutes}`);
              }}
            />
          </div>
        </LocalizationProvider>
      </div>
    </StyledNotAllDayPicker>
  );
}

export default NotAllDayPicker;
